module.exports = __webpack_public_path__ + "static/cover-1-ac3d63adff166042c5a568c69c4a5366.jpg";